import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { ActionIcon } from '../../assets/SvgIcons';
import { ClickAwayListener } from '@material-ui/core';
import { CircularProgress, List, ListItemButton, ListItemText, Menu, useTheme } from '@mui/material';
import { RowProps } from '../../components/dashboard/table/Account';
import { useDispatch, useSelector } from 'react-redux';
import { getAofFrom, setAppliedFundsFilters, setExploreMutualFundsPageVisited, setSelectedSchemesObj } from '../../redux-store/actions/investorProfile';
import { useHistory } from 'react-router';
import { setPortfolioHeldawayStatus, storeSelectedPortfolio } from '../../redux-store/actions/portfolioFilter';
import { reportDownload, urlFileDownload } from '../../components/Reports/report-utils';
import { useSnackbar } from 'notistack';
import { downloadFile, isModuleAllowed, maskInfo } from '../../utils/utilityFunctions';
import { RootStateType } from '../../redux-store/reducers';

const investorOptions = [
    'AOF Form',
];

const portfolioOptions = [
    'View Portfolio',
    'Explore Mutual Funds',
]


interface Props {
    data: RowProps | undefined
    filterValue: number
    isToggle: boolean
}

export default function IconCustomeDropDown(props: Props) {
    const { data, filterValue, isToggle } = props
    const { palette } = useTheme()
    const dispatch = useDispatch()
    const history = useHistory()
    const { enqueueSnackbar } = useSnackbar();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [isLoading, setIsLoading] = React.useState<boolean>(false)
    const [selectedIndex, setSelectedIndex] = React.useState<number | null>(null);
    const open = Boolean(anchorEl);

    const { permissions } = useSelector((store: RootStateType) => store.auth);

    const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (
        event: React.MouseEvent<HTMLElement>,
        index: number,
    ) => {
        setSelectedIndex(index);
        if (index === 0) {
            dispatch(storeSelectedPortfolio({ label: '', value: '' }))
            history.push(`/investor-profile/${filterValue === 1 ? maskInfo(data?.customerName || "") : maskInfo(data?.familyName || "")}`, {
                clientCode: (data?.clientCode || "") as string,
                portfoiloId: data?.portfoiloId || "",
            })
        } else if (index === 1) {
            dispatch(setAppliedFundsFilters([]));
            dispatch(setSelectedSchemesObj({}));
            dispatch(setExploreMutualFundsPageVisited(false));
            dispatch(storeSelectedPortfolio({ label: maskInfo(data?.portfolioName as string), value: data?.portfoiloId as string }))
            dispatch(setPortfolioHeldawayStatus(data?.isPortfolioHeldaway ?? false))

            history.push(`/investor-profile/${filterValue === 1 ? maskInfo(data?.customerName || "") : maskInfo(data?.familyName || "")}/mutual-fund/explore`, {
                clientCode: (data?.clientCode || "") as string,
            })
        }

        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const aofFormhandler = async () => {
        try {
            setIsLoading(true)
            const res = await (dispatch(getAofFrom({ clientCode: data?.clientCode as string })) as unknown) as { url: string }

            urlFileDownload(res.url, 'AOF.pdf');
            enqueueSnackbar('File downloaded successfully.', {
                variant: 'success',
                autoHideDuration: 2000,
            });


            setIsLoading(false)

        } catch (err) {
            console.log('err', err)
            setIsLoading(false)
            enqueueSnackbar('File download failed.', {
                variant: 'error',
                autoHideDuration: 2000,
            });
        } finally {
            setAnchorEl(null);
        }
    }


    return (
        <>
            <div>
                <List
                    component="nav"
                    aria-label="Device settings"
                    sx={{ color: 'customColors.infoCardTitle', padding: 0 }}
                >
                    <ListItemButton
                        id="lock-button"
                        aria-haspopup="listbox"
                        aria-controls="lock-menu"
                        aria-label="when device is locked"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClickListItem}
                        disabled={!isToggle && filterValue === 2}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <ActionIcon />
                    </ListItemButton>
                </List>
                <Menu
                    id="lock-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'lock-button',
                        role: 'listbox',
                        style: {
                            padding: '8px',
                            borderRadius: '16px'
                        }
                    }}

                >
                    {filterValue === 1 && isToggle && portfolioOptions.map((option, index) => (
                        <MenuItem
                            key={option}
                            disabled={index === 1 || !isModuleAllowed({ value: "INVDashboard", compareArr: permissions, objKey: "permissonCode" })}
                            // disabled={index === 0}
                            selected={index === selectedIndex}
                            onClick={(event) => handleMenuItemClick(event, index as number)}
                            sx={{
                                '&:focus': {
                                    backgroundColor: palette.primary[50],
                                    color: palette.primary[500],
                                    borderRadius: '8px'
                                },
                            }}
                        >
                            {option}
                        </MenuItem>
                    ))}
                    {filterValue === 1 && !isToggle && investorOptions.map((option, index) => (
                        <MenuItem
                            key={option}
                            disabled={isLoading || !isModuleAllowed({ value: "INVDashboard", compareArr: permissions, objKey: "permissonCode" })}
                            // disabled={index === 0}
                            selected={index === selectedIndex}
                            onClick={(event) => aofFormhandler()}
                            sx={{
                                '&:focus': {
                                    backgroundColor: palette.primary[50],
                                    color: palette.primary[500],
                                    borderRadius: '8px'
                                },
                            }}
                        >
                            {isLoading ? (<CircularProgress size={20} />) : option}

                        </MenuItem>
                    ))}
                    {filterValue === 2 && data?.list?.length as number === 0 && portfolioOptions.map((option, index) => (
                        <MenuItem
                            key={option}
                            disabled={index === 1 || !isModuleAllowed({ value: "INVDashboard", compareArr: permissions, objKey: "permissonCode" })}
                            // disabled={index === 0}
                            selected={index === selectedIndex}
                            onClick={(event) => handleMenuItemClick(event, index as number)}
                            sx={{
                                '&:focus': {
                                    backgroundColor: palette.primary[50],
                                    color: palette.primary[500],
                                    borderRadius: '8px'
                                },
                            }}
                        >
                            {option}
                        </MenuItem>
                    ))}
                    {filterValue === 2 && data?.list?.length as number > 0 && investorOptions.map((option, index) => (
                        <MenuItem
                            key={option}
                            disabled={isLoading || !isModuleAllowed({ value: "INVDashboard", compareArr: permissions, objKey: "permissonCode" })}
                            // disabled={index === 0}
                            selected={index === selectedIndex}
                            onClick={(event) => aofFormhandler()}
                            sx={{
                                '&:focus': {
                                    backgroundColor: palette.primary[50],
                                    color: palette.primary[500],
                                    borderRadius: '8px'
                                },
                            }}
                        >
                            {isLoading ? (<CircularProgress size={20} />) : option}
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        </>
    );
}